import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { Structure } from 'app/shared/models/class/structure/structure';
import { ClubService } from 'app/shared/services/club/club.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { StructureService } from 'app/shared/services/structure/structure.service';
import { UiService } from 'app/shared/services/ui/ui.service';

@Component({
  selector: 'app-admin-structure-add',
  templateUrl: './admin-structure-add.component.html',
  styleUrls: ['./admin-structure-add.component.scss']
})
export class AdminStructureAddComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['clubCode', 'clubName', 'isActive'];
  dataSource: MatTableDataSource<ClubDetails>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  clubs: any = [];

  searchForm: UntypedFormGroup;
  updateStructureForm: UntypedFormGroup;
  valueInput: string;

  structureKey: string;
  structure: Structure;
  clubSelected: ClubDetails[] = [];

  constructor(
    private route: ActivatedRoute,
    private structureService: StructureService,
    private formBuilder: UntypedFormBuilder,
    private clubService: ClubService,
    private router: Router,
    private uiService: UiService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.getClubs();
  }

  onSubmit(): void {
    const newStructure = new Structure(this.f.structureName.value, this.clubSelected);

    if (!this.clubSelected.length) {
      return this.uiService.showSnackbar('Vous devez ajouter des clubs pour valider');
    }
    this.structureService.addStructure(newStructure).subscribe({
      next: () => {
        this.router.navigate(['/admin/structure']);
      }
    });

  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  addOrDeleteCLub(club: ClubDetails): void {
    const indexClub = this.clubSelected.findIndex(cK => cK.clubKey === club.clubKey);

    indexClub !== -1 ?
      this.clubSelected.splice(indexClub, 1) :
      this.clubSelected.push(club);
  }

  clubISelected({ clubKey }): boolean {
    const indexClub = this.clubSelected.findIndex(cK => cK.clubKey === clubKey);
    return indexClub !== -1 ? true : false;
  }

  goBack(): void {
    this.router.navigate(['/admin/structure']);
  }

  private getClubs(): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.clubs = clubs.sort((a, b) => a.clubCode.localeCompare(b.clubCode));
        this.dataSource = new MatTableDataSource<ClubDetails>(this.clubs);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    });

  }

  get f() {
    return this.updateStructureForm.controls;
  }

  private initComponent(): void {
    this.structureKey = this.route.snapshot.queryParams.structureKey;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
    this.updateStructureForm = this.formBuilder.group({
      structureName: [''],
      structureKey: [''],
      clubs: ['']
    });
  }

}
